module.exports = __webpack_public_path__ + "img/2022_10_dandelion_monseki_fin_web.73759028.png";